// -----------------------------------------------------------------------------
// Size master-list (unchanged)
// -----------------------------------------------------------------------------
const sizeArrayList = [
  { sizeValue: 264, sizeName: "600x600" },
  { sizeValue: 262, sizeName: "600x1200" },
  { sizeValue: 266, sizeName: "300x600" },
  { sizeValue: 268, sizeName: "300x300" },
  { sizeValue: 267, sizeName: "300x450" },
  { sizeValue: 257, sizeName: "1200x2400" },
  { sizeValue: 455, sizeName: "800x2400" },
  { sizeValue: 263, sizeName: "800x800" },
  { sizeValue: 260, sizeName: "800x1600" },
  { sizeValue: 272, sizeName: "195x1200" },
  { sizeValue: 258, sizeName: "1200x1200" },
  { sizeValue: 259, sizeName: "1000x1000" },
  { sizeValue: 261, sizeName: "800x1200" },
  { sizeValue: 336, sizeName: "400x400" },
  { sizeValue: 265, sizeName: "395x395" },
  { sizeValue: 269, sizeName: "295x295" },
  { sizeValue: 270, sizeName: "250x375" },
  { sizeValue: 271, sizeName: "200x300" },
  { sizeValue: 273, sizeName: "145x600" },
  { sizeValue: 274, sizeName: "200x1200" },
  { sizeValue: 335, sizeName: "148x600" },
  { sizeValue: 480, sizeName: "300x1200" },
  { sizeValue: 497, sizeName: "1200x1800" },
];

// -----------------------------------------------------------------------------
// mapSizesToProducts – every size gets exactly 4 products, no overlaps
// -----------------------------------------------------------------------------
export function mapSizesToProducts(rawString, products) {
  const SIZE_PER_TILE = 4;

  try {
    /* ---------- 1. clean & parse the size JSON ---------- */
    const jsonPart = rawString.replace(/^<div>|<\/div>$/g, "");
    const fixedJson = jsonPart.replace(/'/g, '"');
    const sizeData = JSON.parse(fixedJson);

    /* ---------- 2. build a lookup { "600x600": 264, … } ---------- */
    const sizeLookup = Object.fromEntries(
      sizeArrayList.map(({ sizeName, sizeValue }) => [sizeName, sizeValue])
    );

    /* ---------- 3. assign products 4-by-4 without overlap ---------- */
    const resultWithoutSizeValue = {};

    let cursor = 0; // global pointer into `products`

    sizeData.forEach((entry) => {
      for (const key in entry) {
        const sizes = entry[key]; // e.g. ["600x600", "300x300", …]

        // initialise bucket for this key once
        if (!resultWithoutSizeValue[key]) {
          resultWithoutSizeValue[key] = [];
        }

        sizes.forEach((size) => {
          const start = cursor;
          const end = start + SIZE_PER_TILE;

          resultWithoutSizeValue[key].push({
            size,
            product: products.slice(start, end), // exactly 4 products
          });

          cursor += SIZE_PER_TILE; // advance for next size
        });
      }
    });

    /* ---------- 4. add sizeValue & return ---------- */
    const finalResult = Object.fromEntries(
      Object.entries(resultWithoutSizeValue).map(([key, arr]) => [
        key,
        arr.map((item) => ({
          ...item,
          sizeValue:
            item.size === "300x300 (Plain Tiles)"
              ? sizeLookup["300x300"]
              : sizeLookup[item.size],
          parking: item.size === "300x300 (Plain Tiles)",
        })),
      ])
    );

    return finalResult;
  } catch (err) {
    console.error("Error parsing size string:", err);
    return {};
  }
}
